var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCarouselArrowLeft = function SvgCarouselArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.951 16.084l.295.265H8.048l-.043-.038L.544 9.726l-.052-.045V7.205l.052-.046L7.876.69 7.92.65h4.201l-.298.266-8.397 7.496 8.526 7.672z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
};
export default SvgCarouselArrowLeft;